export const ASSET_SHAPE_NAME = 'Asset';
export const ASSET_SHAPE_ID = 'ASSET';
export const ASSET_IMAGE_PARAMS_SHAPE_NAME = 'TSAssetImageParams';
export const ASSET_IMAGE_PARAMS_SHAPE_ID = 'TSAssetImageParams';
export const ASSET_IMAGE_SHAPE_NAME = 'TSAssetImage';
export const ASSET_IMAGE_SHAPE_ID = 'TSAssetImage';
export const ASSET_IMAGE_META_SHAPE_NAME = 'TSAssetImageMeta';
export const ASSET_IMAGE_META_SHAPE_ID = 'TSAssetImageMeta';
export const ASSET_UPLOAD_STATUS_PENDING = 'PENDING';
export const ASSET_UPLOAD_STATUS_COMPLETE = 'COMPLETE';
export const ASSET_UPLOAD_STATUS_FAILED = 'FAILED';
